<template>
  <div class="realtime-quote-view">
    <RealtimeQuoteWS />
  </div>
</template>

<script>
import RealtimeQuoteWS from '@/components/quote/RealtimeQuoteWS.vue'

export default {
  name: 'RealtimeQuoteView',
  components: { RealtimeQuoteWS }
}
</script>

<style scoped>
.realtime-quote-view {
  width: 100%;
  height: 100%;
}
</style>
